// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budgetHyphen[data-v-bd572f88] {\n  margin-top: 32px;\n  margin-left: 3px;\n  margin-right: 3px;\n}", ""]);
// Exports
module.exports = exports;
